import axios from "axios"
import hostConfig from "@configs/host"

// export const baseUrl = "192.168.1.124:8080"
// export const baseUrl = "http://109.104.218.17"

const axiosRequest = axios.create({
  baseURL: `${hostConfig.BASE_URL_HTTP}`,
  headers: {
    "Content-type": "application/json"
  }
})
export default axiosRequest
